/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { AsyncPipe } from '@angular/common';
import { NgModule, Pipe, PipeTransform, inject } from '@angular/core';
import { OSKTranslateService } from '../services/translate.service';
import { Observable } from 'rxjs';

/**
 * Custom translate pipe that uses the {@link OSKTranslateService} to get the translations.
 *
 * @usageNotes
 * ```
 *  {{ 'translationKey' | oskTranslate | async }}
 * ```
 * Since the transform method returns an Observable we need the "async" pipe after it
 */
@Pipe({
  name: 'oskTranslate'
})
export class OSKTranslate implements PipeTransform {
  private readonly translate: OSKTranslateService = inject(OSKTranslateService);

  /**
   * Returns the translation based on the key.
   *
   * @param key The translation key
   * @param params Parameters to be used in the translation
   * @returns An observable of the translation message
   */
  transform(key: string, params: object = {}): Observable<string> {
    return this.translate.stream(key, params);
  }
}

@NgModule({
  declarations: [OSKTranslate],
  imports: [AsyncPipe],
  exports: [OSKTranslate, AsyncPipe]
})
export class OSKTranslatePipe {}
